import React, { useState, useEffect } from "react";
import "../Styles/ViewRepresentativeRegistration.css";
import { useNavigate } from "react-router-dom";
import {
  FaFilter,
  FaSearch,
  FaEnvelope,
  FaDownload,
  FaTrash,
  FaCommentDots,
} from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Tpofilter from "../components/AdminDashboard/Tpofilter";

import ApiService from "../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

function ViewRepresentativeRegistration() {
  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [page, setPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);

  const [sendOptions, setSendOptions] = useState({
    email: false,
    whatsapp: false,
    message: false,
  });

  const recordsPerPage = 10;

  /* =========================
     FETCH ONLY APPROVED REPRESENTATIVES
  ========================== */
  useEffect(() => {
    fetchApprovedTpos();
  }, []);

  const fetchApprovedTpos = async () => {
    try {
      const res = await AdminAPI.getRepresentatives();

      console.log("REPRESENTATIVES API =>", res.data);

      const list =
        res.data?.data ||
        res.data?.representatives ||
        res.data ||
        [];

      /*
        API FORMAT:
        [
          {
            member:{},
            details:{}
          }
        ]
      */

      const approvedOnly = list
        .filter((item) => {
          const member = item.member || item;

          return (
            (member.status || "").toLowerCase() === "approved" ||
            member.is_approved === true
          );
        })
        .map((item, index) => {
          const member = item.member || {};
          const details = item.details || {};

          return {
            id:
              member.membership_id ||
              details.member_id ||
              member.id ||
              `REP-${index}`,

            membershipId:
              member.membership_id ||
              details.member_id ||
              member.id,

            name:
              member.full_name ||
              member.name ||
              "",

            phone:
              member.mobile ||
              details.mobile_number ||
              "",

            email:
              member.email ||
              details.official_mail_id ||
              "",

            state:
              member.state ||
              details.state ||
              "",

            organization:
              details.university_name ||
              details.college_name ||
              "",

            designation:
              details.designation ||
              "Representative",

            photo:
              member.profile_pic
                ? member.profile_pic.startsWith("http")
                  ? member.profile_pic
                  : `https://nhrc.onrender.com/${member.profile_pic}`
                : "https://via.placeholder.com/40",

            fullData: item,
          };
        });

      setEmployees(approvedOnly);

    } catch (err) {
      console.error("Error fetching Representatives:", err);
    }
  };

  /* =========================
     SEARCH
  ========================== */
  const filtered = employees.filter((emp) => {
    const term = searchTerm.toLowerCase();

    return (
      emp.name.toLowerCase().includes(term) ||
      emp.phone.toLowerCase().includes(term) ||
      emp.email.toLowerCase().includes(term) ||
      emp.organization.toLowerCase().includes(term) ||
      emp.state.toLowerCase().includes(term) ||
      emp.designation.toLowerCase().includes(term) ||
      String(emp.id).toLowerCase().includes(term)
    );
  });

  /* =========================
     PAGINATION
  ========================== */
  const paginated = filtered.slice(
    (page - 1) * recordsPerPage,
    page * recordsPerPage
  );

  const totalPages = Math.ceil(filtered.length / recordsPerPage) || 1;

  /* =========================
     SELECT
  ========================== */
  const toggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(paginated.map((emp) => emp.id));
    } else {
      setSelectedIds([]);
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((sid) => sid !== id)
        : [...prev, id]
    );
  };

  /* =========================
     DELETE
  ========================== */
  const handleDeleteSelected = () => {
    if (!selectedIds.length) {
      alert("Select at least one representative");
      return;
    }

    setEmployees((prev) =>
      prev.filter((emp) => !selectedIds.includes(emp.id))
    );

    setSelectedIds([]);
  };

  /* =========================
     SEND
  ========================== */
  const handleSendMessages = () => {
    if (!selectedIds.length) {
      alert("Select at least one representative");
      return;
    }

    const channels = [];

    if (sendOptions.email) channels.push("Email");
    if (sendOptions.whatsapp) channels.push("WhatsApp");
    if (sendOptions.message) channels.push("Message");

    if (!channels.length) {
      alert("Select communication method");
      return;
    }

    alert(`Sending via ${channels.join(", ")}`);
  };

  /* =========================
     DOWNLOAD EXCEL
  ========================== */
  const handleDownloadSelected = () => {
    if (!selectedIds.length) {
      alert("Select representatives");
      return;
    }

    const selected = employees.filter((emp) =>
      selectedIds.includes(emp.id)
    );

    const data = selected.map((emp) => ({
      "Member ID": emp.id,
      Name: emp.name,
      Phone: emp.phone,
      Email: emp.email,
      State: emp.state,
      Organization: emp.organization,
      Designation: emp.designation,
    }));

    const ws = XLSX.utils.json_to_sheet(data);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Representatives");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "Approved_Representatives.xlsx");
  };

  return (
    <div className="empviewtpo-container">

      {/* HEADER */}
      <div className="empviewtpo-header-bar">
        <h2>REPRESENTATIVE REGISTRATION (APPROVED ONLY)</h2>

        <p>
          Total Approved: <b>{employees.length}</b>
        </p>
      </div>

      {/* ACTION BAR */}
      <div className="empview-action-bar">

        <button
          className="empview-filter-btn"
          onClick={() => setOpenFilter(true)}
        >
          <FaFilter /> Filter
        </button>

        <div className="empview-search-box">
          <FaSearch />

          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <button
          className="empview-delete-btn"
          onClick={handleDeleteSelected}
        >
          <FaTrash /> Delete
        </button>
      </div>

      {/* TOOLBAR */}
      <div className="empview-toolbar">

        <label>
          {selectedIds.length} Selected
        </label>

        <label>
          <input
            type="checkbox"
            checked={sendOptions.email}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                email: !p.email,
              }))
            }
          />

          <FaEnvelope /> Email
        </label>

        <label>
          <input
            type="checkbox"
            checked={sendOptions.whatsapp}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                whatsapp: !p.whatsapp,
              }))
            }
          />

          <IoLogoWhatsapp /> WhatsApp
        </label>

        <label>
          <input
            type="checkbox"
            checked={sendOptions.message}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                message: !p.message,
              }))
            }
          />

          <FaCommentDots /> Message
        </label>

        <button
          className="empview-download-btn"
          onClick={handleDownloadSelected}
        >
          <FaDownload /> Download
        </button>

        <button
          className="empview-send-btn"
          onClick={handleSendMessages}
        >
          Send
        </button>
      </div>

      {/* TABLE */}
      <div className="empview-table-container">

        <table className="empview-table">

          <thead>
            <tr>

              <th>
                <input
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    paginated.length > 0 &&
                    selectedIds.length === paginated.length
                  }
                />
              </th>

              <th>Member ID</th>
              <th>Profile</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>State</th>
              <th>Organization</th>
              <th>Designation</th>
              <th>Actions</th>

            </tr>
          </thead>

          <tbody>

            {paginated.length > 0 ? (
              paginated.map((emp) => (
                <tr key={emp.id}>

                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(emp.id)}
                      onChange={() => toggleSelect(emp.id)}
                    />
                  </td>

                  <td>{emp.id}</td>

                  <td>
                    <img
                      src={emp.photo}
                      alt={emp.name}
                      className="empview-profile-pic"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </td>

                  <td>{emp.name}</td>

                  <td>{emp.phone}</td>

                  <td>{emp.email}</td>

                  <td>{emp.state}</td>

                  <td>{emp.organization}</td>

                  <td>{emp.designation}</td>

                  <td>

                    <button
                      className="empview-view-btn"
                      onClick={() =>
                        navigate("/dashboard/TporegView", {
                          state: {
                            membershipId:
                              emp.membershipId || emp.id,
                          },
                        })
                      }
                    >
                      View Details
                    </button>

                  </td>

                </tr>
              ))
            ) : (
              <tr>

                <td colSpan="10">
                  No approved representatives found
                </td>

              </tr>
            )}

          </tbody>

        </table>
      </div>

      {/* PAGINATION */}
      <div className="empview-pagination">

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Prev
        </button>

        <span>
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>

      </div>

      {/* FILTER */}
      {openFilter && <Tpofilter />}

    </div>
  );
}

export default ViewRepresentativeRegistration;